<template>
    <component :is="component" v-if="component" :class="iconClass" />
    <span v-else :class="iconClass"></span>
</template>

<script>
/**
 * Icon component. Will load the icon dynamically.
 *
 * @version 4.0.0
 * @example ./examples/Icon.md
 */
export default {
    name: 'Icon',
    props: {
        /**
         * Icon name. Check available [names](#/Globals/Icons)
         */
        name: {
            type: String,
            default: '',
        },
        /**
         * Icon size. Available sizes: `medium`, `small`, `xs`, `xxs`
         */
        size: {
            type: String,
            default: null,
        },
        /**
         * Icon color. Check available [colors](#/Globals/Colors)
         */
        color: {
            type: String,
            default: null,
        },
        /**
         * Whether or not icon is spinning
         */
        spin: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            component: null,
        };
    },
    computed: {
        iconClass() {
            return {
                icon: true,
                'icon--spin': this.spin,
                [`icon--${this.size}`]: this.size,
                [`color--${this.color}`]: this.color,
            };
        },
    },
    watch: {
        name(newVal, oldVal) {
            if (newVal === oldVal) {
                return;
            }

            this.handleIconLoad();
        },
    },
    created() {
        this.handleIconLoad();
    },
    methods: {
        loadIconComponent(iconName) {
            return import(/* webpackChunkName: "icon-[request]" */ `@/assets/shift/svg/icons/${iconName}.svg`);
        },
        handleIconLoad() {
            if (!this.name) {
                return;
            }

            const iconComponent = this.loadIconComponent(this.name);

            iconComponent
                .then(() => {
                    this.component = () => iconComponent;
                })
                .catch(() => {
                    this.component = () => this.loadIconComponent('generic-drivek-symbol');
                });
        },
    },
};
</script>
